import LegacyCreateMaterialStockLot from './LegacyCreateMaterialStockLot';

export default { LegacyCreateMaterialStockLot };
